import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#586D89", d: "m18.75 17.869-4.719-4.744A6.874 6.874 0 0 0 3.877 3.877a6.874 6.874 0 0 0 9.248 10.154l4.744 4.719.881-.881zM3.125 8.75a5.624 5.624 0 1 1 11.25 0 5.624 5.624 0 1 1-11.25 0z" }));
const ForwardRef = forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
